module.exports = __webpack_public_path__ + "img/rest-house.59ff3a0c.jpg";